import axios from "axios";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import auth from "./auth";

class Http {
  static _lib(...args) {
    var method = args[0].toLowerCase();
    return axios[method](...args.slice(1));
  }

  static _error(e) {
    if (!e.response) {
      return e.request ? new Error(`Request failed!`) : new Error(e.message);
    }
    var { data } = e.response;
    var msg = typeof data == `object` ? JSON.stringify(data) : data;
    return [`status`, `headers`]
      .reduce((err, key) => {
        err[key] = e.response[key];
        return err;
      }, new Error(msg));
  }

  static _request({ method, url, data, options }) {
    return new Promise(async (resolve, reject) => {
      var resp;
      try {
        switch (method) {
          case `PATCH`:
          case `POST`:
          case `PUT`:
            resp = await Http._lib(method, url, data, options);
            break;
          default:
            resp = await Http._lib(method, url, options);
        }
        resolve(resp);
      } catch (e) {
        reject(Http._error(e));
      }
    });
  }

  static delete(url, options) {
    var method = `DELETE`;
    return Http._request({ method, url, options });
  }

  static get(url, options) {
    var method = `GET`;
    return Http._request({ method, url, options });
  }

  static patch(url, data, options) {
    var method = `PATCH`;
    return Http._request({ method, url, data, options });
  }

  static post(url, data, options) {
    var method = `POST`;
    return Http._request({ method, url, data, options });
  }

  static put(url, data, options) {
    var method = `PUT`;
    return Http._request({ method, url, data, options });
  }
}

// Axios request interceptor
axios.interceptors.request.use(async (config) => {
  // start the progress bar
  NProgress.start();

  // Attach a current ID token on every request. Resolving it here rather than
  // in the Api factory keeps the token handling in one place and means the
  // callers keep their synchronous signatures. `getIdToken()` hands back the
  // cached token while it is still valid and renews it once it has expired, so
  // a long-lived tab no longer sends a stale token that the API rejects with
  // `auth/id-token-expired`.
  //
  // This overwrites any `authorization` set upstream (Api._options derives one
  // from the token cached at login, which is the stale value being fixed here).
  try {
    var token = await auth.current();
    if (token) {
      config.headers = config.headers || {};
      config.headers.authorization = `Bearer ${token}`;
    }
  } catch (e) {
    // Never let token retrieval block the request; the API answers 401 and the
    // existing `onAuthStateChanged` flow handles the sign-out.
    console.error(e);
  }

  return config;
});

NProgress.configure({ showSpinner: false });
// Axios response interceptor
axios.interceptors.response.use(
  (response) => {
    NProgress.done();
    return response;
  },
  (error) => {
    NProgress.done();
    return Promise.reject(error);
  }
);

export default Http;
